import { VendiaRuntimeUser } from '../runtime';

export function isSuperUser(user: VendiaRuntimeUser | null | undefined) {
  return user?.roles?.some((role) => role.name === 'super') ?? false;
}

export function can(user: VendiaRuntimeUser | null | undefined, permission: string) {
  if (!user) return false;
  if (isSuperUser(user)) return true;
  return user.all_permissions?.includes(permission) ?? false;
}

export function canAny(user: VendiaRuntimeUser | null | undefined, permissions: string[]) {
  if (!permissions.length) return true;
  return permissions.some((permission) => can(user, permission));
}

export function resourcePermissions(resource: string) {
  return {
    read: `read-${resource}`,
    create: `create-${resource}`,
    update: `update-${resource}`,
    delete: `delete-${resource}`
  };
}
